import { createStyles } from '@mantine/core'

export default createStyles((theme) => ({
  section: {
    padding: '16px',
    border: '1px solid lightgrey',
    borderRadius: '16px',
    gap: '0',
    cursor: 'pointer',
  },
  sectionDisabled: {
    padding: '16px',
    border: '1px solid grey',
    borderRadius: '16px',
    opacity: 0.5,
    gap: '0',
  },
  title: {
    fontWeight: 'bold',
  },
  message: {
    lineHeight: '18px',
  },
}))
